import React, { FC, ReactElement, useState } from 'react'
import { GenericModal, TimezoneModal as TimezoneModalLang } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import Modal from '../../Common/Components/Modal'
import { DocTopic } from '../../Common/Constants/Documentation' // Contexts imports.
import {
    LanguageContextProvider,
    MessageContextProvider,
    PromptContextProvider,
    ReactState
} from '../../Common/Contexts'
import { CommonFormContextProvider } from '../../Common/Contexts/CommonFormContext'
import { clearModalHelpTopic, setModalHelpTopicID } from '../../Common/Utils/HelpPortal'
import { Timezone } from '../Main/Timezone'
import { $window } from '../../../NonReact/common/AkixiWindow'

const TimezoneModal: FC = (): ReactElement => {
    // Access language resources directly without context as this is top level component.
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    language.loadBundle(GenericModal.NAME)
    language.loadBundle(TimezoneModalLang.NAME)

    const [isModalOpen, setModalOpen]: ReactState<boolean> = useState<boolean>(true)

    const closeModal = (): void => {
        $window.disableHotKeys = false
        setModalOpen(false)
    }

    return (
        <CommonFormContextProvider>
            <Modal
                isOpen={isModalOpen}
                classNames='timezone-modal'
                closeOnBackdropClick={true}
                isClosableWithXButton={true}
                inlineExitPromptSettings={{
                    message: language.get(GenericModal.GenericModal_PromptMessage),
                    confirmButtonText: language.get(GenericModal.GenericModal_PromptConfirm),
                    cancelButtonText: language.get(GenericModal.GenericModal_PromptCancel)
                }}
                onOpen={(): void => setModalHelpTopicID(DocTopic.TIMEZONE)}
                onClose={closeModal}
                onExited={(): void => clearModalHelpTopic()}
            >
                {isModalOpen ? (
                    <LanguageContextProvider>
                        <PromptContextProvider>
                            <MessageContextProvider>
                                <div className='modal-title-report-config'>
                                    {language.get(TimezoneModalLang.Timezone_Title_Change)}
                                </div>
                                <Timezone closeModal={closeModal} />
                            </MessageContextProvider>
                        </PromptContextProvider>
                    </LanguageContextProvider>
                ) : (
                    <></>
                )}
            </Modal>
        </CommonFormContextProvider>
    )
}

export default TimezoneModal
